document.documentElement.classList.remove('no-js');
const items = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  }), { threshold: 0.12 });
  items.forEach((item) => observer.observe(item));
} else { items.forEach((item) => item.classList.add('is-visible')); }

const inventoryPage = document.querySelector('[data-inventory-page]');
if (inventoryPage) {
  const universeDetails = {
    all: ['TODOS LOS FUNKOS', 'Explora los personajes disponibles y encuentra el próximo que va a vivir en tu repisa.'],
    'dragon-ball': ['DRAGON BALL', 'Descubre todos los Funkos disponibles de Dragon Ball.'],
    'marvel-dc': ['MARVEL & DC', 'Descubre todos los Funkos disponibles de los universos Marvel y DC.'],
    'los-simpsons': ['LOS SIMPSONS', 'Descubre todos los Funkos disponibles de Los Simpsons.'],
    'naruto-anime': ['ANIME', 'Naruto, Jujutsu Kaisen, One Piece, My Hero Academia y más anime disponible.'],
    naruto: ['ANIME', 'Naruto y otros universos de anime disponibles.'],
    disney: ['DISNEY', 'Personajes de Disney y Pixar disponibles en Komiko.'],
    'tv-cine-terror': ['TV · CINE · TERROR', 'Personajes de series, películas y terror para tu colección.'],
    'gaming-pokemon': ['POKÉMON & GAMING', 'Pokémon, videojuegos y personajes del mundo gaming.'],
    'icons-otros': ['ICONS & OTROS', 'Música, íconos, mascotas de marcas y esas piezas difíciles de clasificar pero fáciles de querer.'],
    'ofertas-1499': ['$14.99 Y MENOS 🔥', 'Funkos a precio de entrada. Una forma fácil de empezar o sumar otro personaje a tu colección.']
  };
  const requestedUniverse = new URLSearchParams(window.location.search).get('universe') || 'all';
  const activeUniverse = Object.prototype.hasOwnProperty.call(universeDetails, requestedUniverse) ? requestedUniverse : 'all';
  const cards = Array.from(inventoryPage.querySelectorAll('[data-inventory-card]'));
  let visibleCount = 0;
  cards.forEach((card) => {
    const categories = (card.dataset.category || '').split(/\s+/).filter(Boolean);
    const visible = activeUniverse === 'all' || categories.includes(activeUniverse);
    card.hidden = !visible;
    if (visible) visibleCount += 1;
  });
  const title = inventoryPage.querySelector('[data-inventory-title]');
  const copy = inventoryPage.querySelector('[data-inventory-copy]');
  const count = inventoryPage.querySelector('[data-inventory-count]');
  const universeInput = inventoryPage.querySelector('[data-inventory-universe-input]');
  if (title) title.textContent = universeDetails[activeUniverse][0];
  if (copy) copy.textContent = universeDetails[activeUniverse][1];
  if (count) count.textContent = visibleCount;
  if (universeInput) universeInput.value = activeUniverse === 'all' ? '' : activeUniverse;
  inventoryPage.querySelectorAll('[data-universe-link]').forEach((link) => {
    const active = link.dataset.universeLink === activeUniverse;
    link.classList.toggle('is-active', active);
    if (active) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
}

document.querySelectorAll('[data-inventory-sort-form]').forEach((form) => {
  const select = form.querySelector('[data-inventory-sort]');
  if (!select) return;
  select.addEventListener('change', () => {
    if (!form.hasAttribute('data-fallback')) { form.submit(); return; }
    const grid = document.querySelector('[data-inventory-grid]');
    if (!grid) return;
    const cards = Array.from(grid.querySelectorAll('[data-inventory-card]'));
    const mode = select.value;
    cards.sort((a, b) => {
      if (mode === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
      if (mode === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
      if (mode === 'title-ascending') return a.dataset.title.localeCompare(b.dataset.title, 'es');
      return Number(a.dataset.newest) - Number(b.dataset.newest);
    });
    cards.forEach((card) => grid.appendChild(card));
  });
});

// Horizontal controls for live new-arrival products.
document.querySelectorAll('[data-product-rail-shell]').forEach((shell) => {
  const rail = shell.querySelector('[data-product-rail]');
  const prev = shell.querySelector('[data-product-rail-prev]');
  const next = shell.querySelector('[data-product-rail-next]');
  if (!rail) return;
  const move = (direction) => {
    const card = rail.querySelector('.product-card');
    const amount = card ? card.getBoundingClientRect().width + 22 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: direction * amount, behavior: 'smooth' });
  };
  if (prev) prev.addEventListener('click', () => move(-1));
  if (next) next.addEventListener('click', () => move(1));
});

// Mobile auto-carousel: Los más HOT de Komiko.
document.querySelectorAll('[data-featured-carousel-shell]').forEach((shell) => {
  const rail = shell.querySelector('[data-featured-carousel]');
  if (!rail) return;
  const cards = [...rail.querySelectorAll('.featured-pick')];
  const prev = shell.querySelector('[data-featured-prev]');
  const next = shell.querySelector('[data-featured-next]');
  const dotsWrap = shell.querySelector('[data-featured-dots]');
  if (cards.length < 1) return;

  let index = 0;
  let timer = null;
  let resumeTimer = null;

  const mobile = () => window.matchMedia('(max-width: 620px)').matches;

  if (dotsWrap) {
    cards.forEach(() => {
      const dot = document.createElement('span');
      dotsWrap.appendChild(dot);
    });
  }
  const dots = dotsWrap ? [...dotsWrap.children] : [];

  const setActive = (i) => {
    index = (i + cards.length) % cards.length;
    cards.forEach((card, n) => card.classList.toggle('is-active', n === index));
    dots.forEach((dot, n) => dot.classList.toggle('is-active', n === index));
  };

  const goTo = (i, behavior = 'smooth') => {
    if (!mobile()) return;
    setActive(i);
    const card = cards[index];
    const left = card.offsetLeft - (rail.clientWidth - card.clientWidth) / 2;
    rail.scrollTo({ left: Math.max(0, left), behavior });
  };

  const stopAuto = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };
  const startAuto = () => {
    stopAuto();
    if (!mobile() || cards.length < 2) return;
    timer = setInterval(() => goTo(index + 1), 3600);
  };
  const pauseThenResume = () => {
    stopAuto();
    if (resumeTimer) clearTimeout(resumeTimer);
    resumeTimer = setTimeout(startAuto, 6500);
  };

  if (prev) prev.addEventListener('click', () => { goTo(index - 1); pauseThenResume(); });
  if (next) next.addEventListener('click', () => { goTo(index + 1); pauseThenResume(); });
  rail.addEventListener('pointerdown', pauseThenResume, { passive: true });
  rail.addEventListener('touchstart', pauseThenResume, { passive: true });

  let scrollTick = null;
  rail.addEventListener('scroll', () => {
    if (!mobile()) return;
    if (scrollTick) cancelAnimationFrame(scrollTick);
    scrollTick = requestAnimationFrame(() => {
      const center = rail.scrollLeft + rail.clientWidth / 2;
      let best = 0, bestDist = Infinity;
      cards.forEach((card, n) => {
        const c = card.offsetLeft + card.clientWidth / 2;
        const d = Math.abs(c - center);
        if (d < bestDist) { bestDist = d; best = n; }
      });
      setActive(best);
    });
  }, { passive: true });

  const syncMode = () => {
    stopAuto();
    if (mobile()) {
      goTo(index, 'auto');
      startAuto();
    } else {
      cards.forEach(card => card.classList.remove('is-active'));
      dots.forEach(dot => dot.classList.remove('is-active'));
    }
  };
  window.addEventListener('resize', syncMode);
  document.addEventListener('visibilitychange', () => document.hidden ? stopAuto() : startAuto());
  syncMode();
});


// Keep a simple first-touch source so Komiko can learn which channels create buyers.
(() => {
  try {
    const params = new URLSearchParams(window.location.search);
    const explicit = params.get('utm_source');
    let source = explicit;
    if (!source && document.referrer) {
      const host = new URL(document.referrer).hostname.toLowerCase();
      if (host.includes('instagram')) source = 'instagram';
      else if (host.includes('tiktok')) source = 'tiktok';
      else if (host.includes('facebook') || host.includes('fb.')) source = 'facebook';
      else if (host.includes('google')) source = 'google';
      else source = host;
    }
    if (!source) source = 'direct';
    if (!localStorage.getItem('komiko_first_source')) localStorage.setItem('komiko_first_source', source);
    const firstSource = localStorage.getItem('komiko_first_source');
    if (firstSource && window.fetch) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({attributes: {'Fuente de primera visita': firstSource}})
      }).catch(() => {});
    }
  } catch (e) {}
})();
